const defaultState = {};

const mutations = {
    setComponentState(state, component) {
        Object.assign(state, component);
    },
    resetComponentState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getComponentInfo({ commit, dispatch }, componentId) {
        try {
            const { data } = await this.$rq.getComponentInfo(componentId);
            commit('setComponentState', data);
        } catch (err) {
            dispatch('resetComponentInfo');
        }
    },
    resetComponentInfo({ commit }) {
        commit('resetComponentState');
    },
};

const getters = {
    component: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
